import React, { useState } from "react";
import "./linkmodal.css";

interface LinkModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { url: string; nofollow: boolean }) => void;
}

const LinkModal: React.FC<LinkModalProps> = ({ open, onClose, onSubmit }) => {
  const [url, setUrl] = useState("");
  const [nofollow, setNofollow] = useState(false);

  if (!open) return null;

  return (
    <div className="link-modal-backdrop">
      <div className="link-modal">
        <h3>Chèn liên kết</h3>

        <input
          type="text"
          placeholder="https://example.com"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />

        <label className="checkbox">
          <input
            type="checkbox"
            checked={nofollow}
            onChange={(e) => setNofollow(e.target.checked)}
          />
          NoFollow (SEO)
        </label>

        <div className="actions">
          <button type="button" onClick={onClose}>
            Hủy
          </button>
          <button
            type="button"
            className="primary"
            onClick={() => {
              if (!url) return;
              onSubmit({ url, nofollow });
              setUrl("");
              setNofollow(false);
            }}>
            Chèn link
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkModal;
